export default __webpack_public_path__ + "static/media/deleteEnable.cd907df6.svg";